import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const HealthRecords = lazyPage(() => import('@/pages/health/MedicalRecords'));
const HealthIncidents = lazyPage(() => import('@/pages/health/Incidents'));

export const healthRoutes: AppRoute[] = [
  {
    path: 'health',
    title: 'Health & Medical',
    children: [
      { path: '', title: 'Health & Medical', component: ModuleMenu },
      { path: 'records', title: 'Medical Records', component: HealthRecords },
      { path: 'incidents', title: 'Incidents', component: HealthIncidents },
    ],
  },
];
